<template>
    <div class="page">
        <v-container class="pb-0"><v-btn text color="primary" :to="{name:'my-reports'}"><v-icon left>mdi-file-document-multiple-outline</v-icon>تقاريري السابقة</v-btn></v-container>
        <transition name="fade-transition">
            <MyExamsComponent get-url="/exams/results" />
        </transition>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import MyExamsComponent from './MyExamsComponent.vue'

export default {
    name: "Courses",
    components: {
        MyExamsComponent
    },
    data(){
        return {
            
        }
    },
    computed: {
        ...GlobalComputed,
        
    },
    watch: {
        
    },
    methods: {
        ...GlobalMethods,
        
    },
    mounted(){
    }
};
</script>